import { Typography, Button, DialogActions, DialogTitle } from '@mui/material';
import { fetchJSON, useRefresh } from '../../data/fetch';


export default function DeleteDPDDialog(props) {
  let { rec } = props.open;
  let refresh = useRefresh();
  const submit = async () => {
    let ret = await fetchJSON('POST', '/delivery/dpd/delete/' + rec.id);
    if (ret && ret.error) {
      alert(ret.error);
    } else {
      refresh();
      props.close();
    }
  }

  return (<>
      <DialogTitle>DPD címkék törlése</DialogTitle>
      <Typography sx={{ p: 2 }}>
        Biztosan törölni szeretné a következő DPD címkéket? <br/>
        <b>{rec.trackingnr}</b>
        <br/>
        Ez a művelet visszafordíthatatlan.
        A szállítmányt a DPD-nél lemondjuk.
      </Typography>
      <DialogActions>
        <Button sx={{ color: "text.secondary" }} onClick={() => props.cancel()}>Mégsem</Button>
        <Button variant="contained" type="submit" onClick={submit}>DPD címkék törlése</Button>
      </DialogActions>
  </>)
}
